module.exports = __webpack_public_path__ + "static/media/home.e1b48fe5.svg";